module.exports = "/images/vendor/tui-image-editor/dist/svg/icon-b.svg?b319e9832828175358d552041e2ae4fd";